import JabelButton from "../components/JabelButton"
import MyNav from "../components/MyNav"
import Divider from "../components/Divider"
import FooterHome from "../components/FooterHome"
import FrameworkBox from "../components/FrameworkBox"
import reactlogo from '../images/reactLogo.png';
import tailwindlogo from '../images/tailwindlogo.jpg'
import awslogo from '../images/awslogo.jpg';
import androidLogo from '../images/android.svg';
import appleLogo from '../images/apple.svg';
import staticLogo from '../images/static.svg';
import fullstackLogo from '../images/fullstack.svg';
import { useNavigate } from "react-router";
import { animateScroll } from "react-scroll"

export default function About({ isSmallScreen }) {
    const navigate = useNavigate();
    animateScroll.scrollToTop({ duration: 1, smooth: false });
    return (
        <div className="text-[#252121]">
            <MyNav aboutB={true} isSmallScreen={isSmallScreen} />
            <div className="px-4 sm:px-[150px]">
                <p className="text-[2.2rem] sm:text-[3.5rem] font-playfair font-semibold pt-16 sm:pt-[7rem] leading-tight">
                    About Us
                </p>
                <p className="text-[1.5rem] sm:text-[3rem] font-playfair pt-10 sm:pt-[7rem] pb-6 sm:pb-[3rem] leading-tight">
                    Our Story
                </p>
                <p className="text-[1rem] sm:text-[1.3rem] font-montserrat pb-10 sm:pb-[6rem] sm:px-[4rem]">
                    We are an Omani-based company, established in 2024 by two individuals with a deep passion for web and application development.
                </p>
                <Divider />
                <div>
                    <p className="py-8 sm:py-[8rem] text-[1rem] sm:text-[1.3rem] font-montserrat sm:px-[5rem]">
                        We at Jabel Net have mastered the following frameworks to complete our tasks, bringing you the best of each world
                    </p>
                </div>
            </div>
            <div className="space-y-8 sm:space-y-0 sm:grid sm:grid-cols-3 sm:gap-8 px-4 sm:px-0">
                <FrameworkBox isSmallScreen={isSmallScreen} bgCol={'#222222'} text={"We use React JS to handle the front-end in any way you'd need, including dynamic content and much more!"} title={"React JS / React Native"} twoP={true} image={reactlogo} />
                <FrameworkBox isSmallScreen={isSmallScreen} bgCol={'#151D2C'} text={"We also use Tailwind to style your websites & animate them, making things more lively and colorful, as per your needs."} title={'Tailwind CSS'} image={tailwindlogo} />
                <FrameworkBox isSmallScreen={isSmallScreen} bgCol={'#232E3E'} text={"To make your website alive on the internet, we use a cloud-based server called AWS, it handles your database along with hosting it for you and whomever accesses it."} title={"AWS Cloud"} image={awslogo} />
            </div>
            <div className="px-4 sm:px-[150px]">
                <p className="text-[1.3rem] sm:text-[2rem] font-playfair pt-10 sm:pt-[7rem] pb-6 sm:pb-[3rem] ">What We Offer:</p>
                <ol className="text-[1rem] sm:text-[1.3rem] font-montserrat space-y-4 sm:space-y-3 pb-10 sm:pb-[4rem] w-full">
                    <li className="flex flex-col sm:flex-row items-start sm:items-center w-full gap-2 sm:space-x-1">
                        <img src={staticLogo} width={40} className="sm:w-[50px]" alt="icon for static websites" />
                        <span>
                            <strong>Static websites </strong>like ones you'd see as portfolios for companies
                        </span>
                    </li>
                    <li className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:space-x-1">
                        <img src={fullstackLogo} width={40} className="sm:w-[50px]" alt="icon for fullstack websites" />
                        <span>
                            <strong>Fullstack websites</strong> like e-shops or websites where signing up is a thing.
                        </span>
                    </li>
                    <li className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:space-x-1">
                        <div className="flex gap-2">
                            <img src={appleLogo} width={28} className="sm:w-[32px]" alt="icon for ios" />
                            <img src={androidLogo} width={28} className="sm:w-[32px]" alt="icon for android" />
                        </div>
                        <span>
                            <strong>IOS & Android apps</strong> with all the functionality and designs that come with it, depending on your needs.
                        </span>
                    </li>
                </ol>
                <Divider />
                <p className="text-[1.3rem] sm:text-[2rem] font-playfair pt-10 sm:pt-[7rem] pb-6 sm:pb-[3rem]">Why Choose Us?</p>
                <p className="text-[1rem] sm:text-[1.3rem] font-montserrat pb-10 sm:pb-[6rem] sm:px-[4rem]">
                    We turn our experience and passion in our field into products made with care and love, providing our clients with the best experience possible is our <strong>#1 priority</strong>; as we will focus heavily on our client's goal and everything after that's done accordingly.
                </p>
                <Divider />
                <p className="text-[1.3rem] sm:text-[2rem] font-playfair pt-10 sm:pt-[7rem] pb-6 sm:pb-[3rem]">Testimonials:</p>
                <ul className="text-[1rem] sm:text-[1.3rem] font-montserrat space-y-8 sm:space-y-10 list-disc pb-10 sm:pb-[4rem] sm:px-[4rem]">
                    <li className="border-l-4 border-blue-800 pl-4 italic">
                        ”Working with Hamzah on our website was an absolute pleasure. His creativity and dedication to inclusivity truly stood out, making our site not only engaging but also accessible for visually impaired individuals. Thank you, Hamzah, for bringing our vision to life so beautifully.“ <br />- <span className="not-italic font-bold">Basirah</span>
                    </li>
                    <li className="border-l-4 border-blue-800 pl-4 italic">
                        ”I highly recommend the team at Jabel Net for building or remodeling your website. I found them to be trustworthy, knowledgeable, and creative in their work on my website questmin.org.  They were easy to work with, while also adhering to sound business practices. Whether for a business, a non-profit organization, or a special project, you can rely on Jabel Net to deliver a beautiful product.“ - <span className="not-italic font-bold">Stan Bohall ~ Quest Ministries</span>
                    </li>
                </ul>
                <Divider />
                <div className="flex justify-center items-center pb-8 sm:pb-[3rem] pt-4 sm:pt-[1rem]">
                    <JabelButton action={() => { navigate('/get-started') }} text={'Get started'} final={true} icon={true} />
                </div>
            </div>
            <FooterHome isSmallScreen={isSmallScreen} />
        </div>
    );
}
